import React from 'react';
import { Divider, DividerProps } from 'semantic-ui-react';

export type IATMDividerProps = DividerProps;

export const ATMDivider: React.FC<DividerProps> = ({ children, ...props }) => (
  <Divider {...props}>{children}</Divider>
);
